import { errors } from '@yola/ws-sdk';

const catchReduxError = (error, getState, lastAction) => {
  errors.operations.catchError(error, errors.types.CRITICAL_ERROR, { action: lastAction });
};

export default catchReduxError;
